import API, { config } from './_main';
import * as AlertModule from 'Modules/AlertModule';
import { AxiosPromise } from 'axios';

export function updateAlert(alertId: number, modifiedAlertData: AlertModule.Types.ModifyAlertDefinitionRequest): AxiosPromise<AlertModule.Types.AlertDefinitionsResponse> {
    return API.put(`alert/definition/${alertId}`, modifiedAlertData, config());
}

export function deleteAlert(alertId: number) {
    return API.delete(`alert/definition/${alertId}`, config());
}

export function getUserAlerts(params?: URLSearchParams): AxiosPromise<AlertModule.Types.AlertDefinitionsResponse> {
    return API.get(`alert/definition`, config(params));
}

export function getAlertById(alertId: number): AxiosPromise<AlertModule.Types.GetAlertDefinitionResponse> {
    return API.get(`alert/definition/${alertId}`, config());
}

export function createAlert(alertData: AlertModule.Types.CreateAlertDefinitionRequest): AxiosPromise<AlertModule.Types.AlertDefinitionsResponse> {
    return API.post('alert/definition', alertData, config());
}

export function getCarAlerts(carId: number): AxiosPromise<AlertModule.Types.AlertDefinitionsResponse> {
    return API.get(`alert/definition/${carId}`, config());
}

export function enableAlert(alertId: number): AxiosPromise<AlertModule.Types.AlertDefinitionsResponse> {
    return API.post(`alert/definition/${alertId}/enable`, null, config());
}

export function disableAlert(alertId: number): AxiosPromise<AlertModule.Types.AlertDefinitionsResponse> {
    return API.post(`alert/definition/${alertId}/disable`, null, config());
}
export function getAlertHistoryLog(params?: URLSearchParams): AxiosPromise<AlertModule.Types.AlertHistoryLogResponse> {
    return API.get(`alert/history-log`, config(params));
}



// WEBPACK FOOTER //
// ./src/Connectors/AlertConnector.ts